import styled from 'styled-components';
import { renderStyledElementStyles } from '../../../../../helpers';

export const Wrapper = styled.div`
  ${({ theme }) => renderStyledElementStyles(theme, theme.module.vStyles)}
  ${({ theme }) =>
    renderStyledElementStyles(theme, theme.module.dStyles?.elements?.wrapper)}
`;
